import tw from 'twin.macro';
import styled from 'styled-components';

const Heading6 = styled.h6(() => [tw`text-lg md:text-xl mt-6 mb-4 font-medium`]);

export default Heading6;
